import { Link } from "react-router-dom";
import { HelpCircle, LifeBuoy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PublicHeader } from "@/components/layout/public-header";
import { SupportFaq } from "@/components/support/support-faq";
import { useAuth } from "@/lib/auth/AuthContext";

/**
 * „Dažni klausimai" — /duk, and public.
 *
 * Public is the point. It was a fold inside the support panel, which put it
 * behind signing in — so the one page that can answer somebody who cannot get
 * into the app was the one page they could not reach. It is also what the 404
 * now links to: /pagalba bounces a stranger to a login card, and this does not.
 *
 * The entries are the same twelve the triage model is given (content/faq.yml), so
 * reading the answer yourself and being told it by the AI cannot diverge.
 *
 * Outside the sidebar shell for the reason `/invitations/:token` is: the person
 * here may have no account, and a shell full of a household's navigation is not
 * for them. Signed in, the way on is „Parašyk mums"; signed out, it is the
 * public header's own doors.
 */
export default function FaqPage() {
  const { authenticated } = useAuth();

  return (
    <div className="min-h-screen">
      {!authenticated && <PublicHeader action="both" />}

      <div className="mx-auto max-w-2xl px-4 py-6 sm:px-6 sm:py-10">
        <h1 className="flex items-center gap-2 text-3xl font-bold tracking-tight">
          <HelpCircle className="h-7 w-7 text-primary" />
          Dažni klausimai
        </h1>
        <p className="mt-2 text-muted-foreground">
          Dažniausios priežastys ir ką su jomis daryti.
        </p>

        <div className="mt-6">
          <SupportFaq bare />
        </div>

        {/* The way on, and it is deliberately at the bottom: somebody who came
            here to read has not yet decided they need a person. */}
        <div className="mt-8 flex flex-wrap items-center gap-3 rounded-lg border bg-muted/30 px-4 py-3.5">
          <p className="text-sm text-muted-foreground">Neradai atsakymo?</p>
          {authenticated ? (
            <Button asChild size="sm" className="ml-auto">
              <Link to="/pagalba">
                <LifeBuoy className="mr-1.5 h-3.5 w-3.5" />
                Parašyk mums
              </Link>
            </Button>
          ) : (
            <p className="ml-auto text-sm text-muted-foreground">
              Prisijunk ir parašyk mums — atsakysime.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
